import React from "react";
import {
  CheckCircleTwoTone,
  CloseCircleFilled,
  WarningTwoTone,
} from "@ant-design/icons";
import { Descriptions, Tooltip } from "antd";

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent); //if Mobile

export default ({ contract }) => {
  const columns = contract.isApplicants ? 10 : 9;
  const amazonApiStatus = getAmazonApiStatus(contract);

  return (
    <Descriptions size="small" column={isMobile ? 2 : columns}>
      <Descriptions.Item label="Target">
        <Tooltip title={contract.manualTarget ? "contract" : "campaigns"}>
          {contract.target}
        </Tooltip>
      </Descriptions.Item>
      {contract.isApplicants && (
        <Descriptions.Item label="Applicants">
          {contract.totalApplicants}
        </Descriptions.Item>
      )}
      {contract.throttle && (
        <Descriptions.Item
          label="Throttle"
          contentStyle={{ alignItems: "center" }}
        >
          <CheckCircleTwoTone twoToneColor="#52c41a" />
        </Descriptions.Item>
      )}
      {contract.metaPartnershipAdsEnabled && (
        <Descriptions.Item
          label="Partnership Ads"
          contentStyle={{ alignItems: "center" }}
        >
          <CheckCircleTwoTone twoToneColor="#52c41a" />
        </Descriptions.Item>
      )}
      {amazonApiStatus && (
        <Descriptions.Item
          label="Amazon APIs"
          contentStyle={{ alignItems: "center" }}
        >
          <Tooltip title={amazonApiStatus.tooltip}>
            {amazonApiStatus.icon}
          </Tooltip>
        </Descriptions.Item>
      )}
      <Descriptions.Item label="Fee">${contract.fee}</Descriptions.Item>
      {/* Revenue is stored in database as 2723000, convert to Millions with no decimal, round up */}
      <Descriptions.Item label="Revenue">
        {contract.revenue && contract.revenue > 1
          ? `$${Math.ceil(contract.revenue / 1000000)}M`
          : "N/A"}
      </Descriptions.Item>
      <Descriptions.Item label="Onboards">
        {contract.totalOnboards}
      </Descriptions.Item>
      {/* <Descriptions.Item label="Not Started">
        {contract.not_started}
      </Descriptions.Item>
      <Descriptions.Item label="Started">{contract.started}</Descriptions.Item> */}
      <Descriptions.Item label="Done">{contract.done}</Descriptions.Item>
      <Descriptions.Item label="Billed">
        {contract.billed || 0}
      </Descriptions.Item>
      <Descriptions.Item label="CTR">{contract.followed_up}</Descriptions.Item>
      <Descriptions.Item label="Not Interested">
        {contract.not_interested}
      </Descriptions.Item>
    </Descriptions>
  );
};

function getAmazonApiStatus({
  amazonApiEnabled,
  amazonSpLinked,
  amazonAttributionLinked,
}) {
  if (!amazonApiEnabled) return null;

  const bothLinked = amazonSpLinked && amazonAttributionLinked;
  const noneLinked = !amazonSpLinked && !amazonAttributionLinked;

  if (noneLinked) {
    return {
      tooltip:
        "APIs enabled but neither Selling Partner API nor Attribution API are linked",
      icon: <CloseCircleFilled style={{ color: "#ff4d4f" }} />,
    };
  }

  if (bothLinked) {
    return {
      tooltip:
        "Both Selling Partner API and Attribution API are linked. No further action is needed.",
      icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    };
  }

  const linked = amazonSpLinked ? "Selling Partner API" : "Attribution API";
  const missing = amazonSpLinked ? "Attribution API" : "Selling Partner API";
  return {
    tooltip: `${missing} is not linked and needs action. ${linked} is linked.`,
    icon: <WarningTwoTone twoToneColor="#fa8c16" />,
  };
}
